const publishToolEvent = (name, detail) => {
  if (!globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
  try { globalThis.Shopify?.analytics?.publish?.(name, detail)?.catch?.(() => {}); } catch { /* Analytics must never interrupt shopping. */ }
};
class ModelPartsFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const select = this.querySelector('select');
    const groups = [...this.querySelectorAll('[data-model-group]')];
    const status = this.querySelector('[data-model-status]');
    if (!select || !status) return;
    const update = () => {
      let count = 0;
      for (const group of groups) {
        group.hidden = Boolean(select.value && group.dataset.modelGroup !== select.value);
        if (!group.hidden) count++;
      }
      status.textContent = `${count} ${count === 1 ? 'model' : 'models'} shown`;
    };
    select.addEventListener('change', () => {
      update();
      publishToolEvent('shop_model_filter_changed', { tool: 'parts_finder', product_id: select.value || 'all' });
    });
    update();
  }
}
class ProductComparison extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const inputs = [...this.querySelectorAll('[data-compare-choice]')];
    const status = this.querySelector('[data-compare-status]');
    const update = (changed) => {
      let selected = inputs.filter(i => i.checked);
      if (selected.length < 2) {
        if (changed) changed.checked = true;
        if (status) status.textContent = 'Keep at least two products selected to compare.';
        return;
      }
      for (const input of inputs) {
        for (const cell of this.querySelectorAll('[data-compare-column]')) {
          if (cell.dataset.compareColumn === input.value) cell.hidden = !input.checked;
        }
      }
      if (status) status.textContent = `Comparing ${selected.length} products. Scroll the table sideways on a small screen.`;
    };
    inputs.forEach(input => input.addEventListener('change', () => {
      update(input);
      publishToolEvent('shop_comparison_changed', { tool: this.dataset.tool || 'comparison', selected_count: inputs.filter(i=>i.checked).length });
    }));
    update();
  }
}
if (!customElements.get('model-parts-finder')) customElements.define('model-parts-finder', ModelPartsFinder);
if (!customElements.get('product-comparison')) customElements.define('product-comparison', ProductComparison);
document.addEventListener('click', event => {
  const link = event.target.closest?.('a[data-shop-tool]');
  if (!link) return;
  publishToolEvent('shop_product_help_clicked', { tool: link.dataset.shopTool, product_id: link.dataset.productId || '' });
});
const searchContext = document.getElementById('shop-tools-context');
let searchViewSent = false;
const publishSearchView = () => {
  if (searchViewSent || !globalThis.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
  try {
    const context = JSON.parse(searchContext?.textContent || '{}');
    if (context.page !== 'search' || typeof context.results_count !== 'number') return;
    publishToolEvent('shop_search_results_viewed', { results_count: context.results_count, zero_results: context.results_count === 0 });
    searchViewSent = true;
  } catch { /* Optional context must never interrupt navigation. */ }
};
publishSearchView();
document.addEventListener('visitorConsentCollected', publishSearchView);
